export default {

    computed: {
        _formatDate:  function(){
            return $sessao.getDateFormat();
        },
    },

    methods: {

		_dateFormat(data, format, formatRetorno){

			return new moment(data, format).format(formatRetorno)

		},

		_dateToDateSQL(data, mascara){

			if(data == "" || data == null || _.isNil(data)){
				return ""
			}


			if(mascara == "DD/MM/YYYY"){
				var dt = data.split("/")
				return (dt[2] + "-" + dt[1] + "-" + dt[0])
			}

			if(mascara == "MM/DD/YYYY"){
				var dt = data.split("/")
				return (dt[2] + "-" + dt[0] + "-" + dt[1])
			}
		},

		_dateTimeToDateSQL(data, mascara){

			if(data == "" || data == null || _.isNil(data)){
				return ""
			}


			if(mascara == "DD/MM/YYYY HH:MM:SS"){
				var item = data.split(" ")
				var dt = item[0].split("/")
				return (dt[2] + "-" + dt[1] + "-" + dt[0] + " " + item[1])

			}

			if(mascara == "MM/DD/YYYY HH:MM:SS"){
				var item = data.split(" ")
				var dt = item[0].split("/")
				return (dt[2] + "-" + dt[0] + "-" + dt[1] + " " + item[1])

			}

			if(mascara == "DD/MM/YYYY HH:MM"){
				var item = data.split(" ")
				var dt = item[0].split("/")
				return (dt[2] + "-" + dt[1] + "-" + dt[0] + " " + item[1])

			}

			if(mascara == "MM/DD/YYYY HH:MM"){
				var item = data.split(" ")
				var dt = item[0].split("/")
				return (dt[2] + "-" + dt[0] + "-" + dt[1] + " " + item[1])

			}
		},

		_SQLDateToDate(data, mascara){


			if(data == "" || data == null || _.isNil(data)){
				return ""
			}

			if(mascara == "DD/MM/YYYY"){
				var dt = data.split("-")
				return (dt[2] + "/" + dt[1] + "/" + dt[0])
			}

			if(mascara == "MM/DD/YYYY"){
				var dt = data.split("-")
				return (dt[1] + "/" + dt[2] + "/" + dt[0])
			}
		},

		_SQLDateToMonthDay(data, mascara){

			if(data == "" || data == null || _.isNil(data)){
				return ""
			}

			if(mascara == "DD/MM/YYYY"){
				var dt = data.split("-")
				return (dt[2] + "/" + dt[1])
			}

			if(mascara == "MM/DD/YYYY"){
				var dt = data.split("-")
				return (dt[1] + "/" + dt[2])
			}
		},

		_SQLDateToDateTime(data, mascara){

			if(data == "" || data == null || _.isNil(data) || data == "0000-00-00" ||  data == "0000-00-00 00:00:00"){
				return ""
			}

			if(mascara == "DD/MM/YYYY HH:MM"){
				var dt = data.split(" ")
				return (dt[0].split("-")[2] + "/" + dt[0].split("-")[1] + "/" + dt[0].split("-")[0] +" "+ dt[1].split(':')[0] + ':' + dt[1].split(':')[1])
			}

			if(mascara == "MM/DD/YYYY HH:MM"){
				var dt = data.split(" ")
				return (dt[0].split("-")[1] + "/" + dt[0].split("-")[2] + "/" + dt[0].split("-")[0] +" "+ dt[1].split(':')[0] + ':' + dt[1].split(':')[1])
			}

			if(mascara == "DD/MM/YYYY HH:MM:SS"){
				var dt = data.split(" ")
				return (dt[0].split("-")[2] + "/" + dt[0].split("-")[1] + "/" + dt[0].split("-")[0] +" "+ dt[1])
			}

			if(mascara == "MM/DD/YYYY HH:MM:SS"){
				var dt = data.split(" ")
				return (dt[0].split("-")[1] + "/" + dt[0].split("-")[2] + "/" + dt[0].split("-")[0] +" "+ dt[1])
			}
		},

		_getDayMes(dia, mes, ano){

			var dt =  (dia < 10 ? '0' + dia : dia) + '/' + mes + '/' +  ano
			var d = new moment(dt, "DD/MM/YYYY")
			return this._traducao('diasSemanaPos', d.weekday())
		},

		_getSabDom(dia){

			var dt =  (dia < 10 ? '0' + dia : dia) + '/' + this.form.mes + '/' +  this.form.ano
			var d = new moment(dt, "DD/MM/YYYY")
			var t = d.day()
			return (t == 0 || t == 6 ) ? true : false
		},
    }

}